import { inject, Component, Inject, TemplateRef, ViewChild, Input, OnChanges, SimpleChanges, AfterViewInit, QueryList, signal, computed, ViewChildren, ElementRef } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DataGridView, DataGridViewCollumn, Types } from "../../../Componente/DataGridView";
import { PopUpView } from "../../../Componente/PopUpView";
import { Geraete} from "../../../Api/DcoApi/Admin/AdminClasses2";
import { FloatingButtonComponent } from "../../../Componente/floatingButton";
import { RestClient, User } from "../../../Api/DcoApi/Client/RestClient";
import { ToastService } from "../../../Akte/Services/Toasts/ToastService";
import { StatusModel } from "../../../Api/DcoApi/Status/StatusModel";
import { PGFilterService } from "../../Services/PGFilterService";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap/modal";
import { DateSelect } from "../../../Akte/Controlls/DateSelect";
import { StatusPipe } from "../../../Pipes/StatusPipe";
import {VersandService} from '../../Services/VersandService';
import {VersandStepper} from '../../../Componente/versand-stepper/versand-stepper';
import {FactoringModel} from '../../../Api/DcoApi/Factoring/FactoringModel';


@Component({
  imports: [
    CommonModule,
    FormsModule,
    DataGridView,
    DataGridViewCollumn,
    PopUpView, FloatingButtonComponent, DateSelect, StatusPipe,VersandStepper
  ],
  selector: 'FactoringStatusView',
  templateUrl: './FactoringStatusView.html',
  standalone: true,
  styleUrl: './FactoringStatusView.css'
})
export class FactoringStatusView implements OnChanges, AfterViewInit {
  @ViewChild('Grid') childComponent!: DataGridView<FactoringModel>;
  toastService: ToastService;
  Types = Types;
  private modalService = inject(NgbModal);

  selectedIDs: number[] = [];

  dataurl = computed(() => { return `/Backend/Api/V2/Factoring` })
  constructor(public pgService: PGFilterService) {
    this.toastService = inject(ToastService)

  }
  ngAfterViewInit(): void {

  }
  ngOnChanges(changes: SimpleChanges): void {

  }

}
